import { render, staticRenderFns } from "./OpenDepreciation.vue?vue&type=template&id=1ffcd0e1&"
import script from "./OpenDepreciation.vue?vue&type=script&lang=ts&"
export * from "./OpenDepreciation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ffcd0e1')) {
      api.createRecord('1ffcd0e1', component.options)
    } else {
      api.reload('1ffcd0e1', component.options)
    }
    module.hot.accept("./OpenDepreciation.vue?vue&type=template&id=1ffcd0e1&", function () {
      api.rerender('1ffcd0e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/assets/Inquiry/OpenDepreciation.vue"
export default component.exports